import type { StatusPillProps } from '@/components/ui';
import type { AdminDesignStatus, AdminMockupStatus } from '@/api/admin';

type PillVariant = StatusPillProps['variant'];

/** Display labels and pill variants shared by the admin design pages. */
export const DESIGN_STATUS_LABEL: Record<AdminDesignStatus, string> = {
  DRAFT: 'Draft',
  ACTIVE: 'Active',
  ARCHIVED: 'Archived',
};

export const DESIGN_STATUS_VARIANT: Record<AdminDesignStatus, PillVariant> = {
  DRAFT: 'draft',
  ACTIVE: 'published',
  ARCHIVED: 'archived',
};

export const MOCKUP_STATUS_LABEL: Record<AdminMockupStatus, string> = {
  PENDING: 'Pending',
  PROCESSING: 'Processing',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
};

export const MOCKUP_STATUS_VARIANT: Record<AdminMockupStatus, PillVariant> = {
  PENDING: 'draft',
  PROCESSING: 'warning',
  COMPLETED: 'published',
  FAILED: 'danger',
};

export { formatAdminDate } from '@/lib/format-date';
